export const dryAlphaGroups = [
  {
    label: "メッキ加工・使用法・微摺動",
    sections: [
      {
        anchor: "drymain01_title01",
        title: "メッキ加工技術",
        html: `部品は機器の精密化・高級化に伴い接触抵抗の信頼性を要求されてきている。表面の貴金属( Au )はコストダウンをはかる意味で0.1um~0.2umの薄膜にして、それと同等以上の特性を持つ部品の開発を目的としているのが現状である。<br>
しかし、表面のメッキ層が多くのピンホールを増すようになるから異種金属の対向による接触電位差の原因で下地の貴金属表面への拡散及び酸化膜などの絶縁物が生じ、接触抵抗の不安定を呼ぶようになってきている現状を掲げることができる。<br>
<br>
<b>[対応のポイント]</b><br>
1.下地金属の拡散性-イオンマイグレーションの低下<br>
2.表面の滑性-摩擦係数の低下<br>
3.接触抵抗の安定性-信頼性<br>
4.加工性-生産性と "ヌレ" , レベリング性<br>
5.非磁性-高周波歪の抑制<br>
6.その他<br>
<br>
即ちピンホールは2um以下の電気メッキでは本質的に除去することは出来ないので下地の金属系と有機系により表面エネルギーを小さくして滑性と防錆を付与する性能改善が効果的である。要するにピンホールに吸着しやすい極性分子構造がすぐれている。<br>
<img src="https://www.factk.jp/factk/images/image1.gif" alt="接触不良要因系統図" class="dryalpha-img"><br>
<img src="https://www.factk.jp/factk/images/image2.gif" alt="有機系封孔処理剤の極性基の付着メカニズム" class="dryalpha-img">`,
      },
      {
        anchor: "drymain01_title02",
        title: "ドライアルファの使用と効果",
        html: `<b>特 徴</b><br>
*簡単・確実で優れた効果が期待できます。(溶剤も各種選択可能です)<br>
*ドライアルファはコネクターなどの挿抜力を低減させ、同時に磨耗も抑制します。<br>
*金メッキなどのピンホール腐食の防止、初期生成化合物の防止、銀製品の変色防止などに安定した効果、及び強力な抑制力があります。<br>
*処理後の皮膜は経年的に安定しており長期にわたって効果が持続いたします、また処理後の製品は未処理のものと比較して日にちが経てばたつほど性能に差が現れます。<br>
*処理後の皮膜はプラスチックスを侵しません。<br>
*濃度管理が簡単で処理コストもひびきません。<br>
*フレッテイングコロージョンを防ぐ為、スズめっき材料にもご使用をお奨めいたします。<br>
*処理後はハンダ付け性に影響無く、酸化及び硫化を防止し耐湿性も向上いたします。<br>
<br>
<b>使 用</b><br>
*生産ラインでご使用の場合は不純物を除去できるろ過装置を併用してください。<br>
*常温で数秒以上ディップ又はスプレイ後、温風エアーナイフ等で溶剤をとばします。<br>
(尚、乾燥時間及び温度により若干赤みが増加しますが性能には一切関係ありません)<br>
*使用目的に応じて×3~×4位で希釈使用して下さい。<br>
*銀製品にD1S系処理をする場合、高濃度で処理を行いますと未反応成分に紫外線が作用する場合がありますので低濃度で処理をするか、又は処理後IPA等で軽洗浄します。<br>
*いづれの溶剤であっても直火の近くで使用しないでください。<br>
*処理後の効果はメッキ条件、種類等によって違いますので、商品化の際には一連の環境試験等でご評価ください。(弊社にご相談いただけましたら幸いです)<br>
<br>
<b>そのほか</b><br>
*溶剤タイプの濃度管理をする際、加熱による重量測定管理が簡単で適切かと思われます。<br>
(アルミシャーレイなどに10g位計量し、オーブン等で溶剤のみ蒸発させた後の残留物を再計量します)<br>
*液自体が長期保管や紫外線の影響で赤みが出る場合がありますが性能には一切影響はありません。<br>
*溶剤により塩化ビニール製の配管部品を侵すものがありますのでご注意ください。<br>
*溶剤により以下の商品がございますのでご検討お願いします。<br>
<br>
<table border="1" cellspacing="0" cellpadding="6" style="width:100%;max-width:660px;border-collapse:collapse;text-align:center;font-size:14px;">
<tbody>
<tr style="background:#e0f7fa;">
<td style="border:1px solid #999;padding:8px;"><b>商 品 名</b></td>
<td style="border:1px solid #999;padding:8px;"><b>溶 剤</b></td>
<td style="border:1px solid #999;padding:8px;"><b>希 釈 溶 剤</b></td>
</tr>
<tr>
<td style="border:1px solid #999;padding:8px;">D1S20P<br>S1シリーズ<br>SAシリーズ</td>
<td style="border:1px solid #999;padding:8px;">イソパラフィン<br>イソパラフィン<br>イソパラフィン</td>
<td style="border:1px solid #999;padding:8px;">イソパラフィン,IPA<br>イソパラフィン,IPA<br>イソパラフィン,IPA他</td>
</tr>
</tbody>
</table>
<br>
参考:D1S20Pの希釈溶剤としてIPAも可能ではございますが水分が混ざり易いので処理前に充分乾燥された状態で処理槽に移して下さい。又、他の溶剤タイプもご用意できますのであわせてご相談およびご用命いただけますようお願い申し上げます。<br>
<br>
姉妹品:S1シリーズ(D1S系より更に良い滑性を持っていますので銀、スズ、ニッケル薄付け金メッキなどにお使い下さい、又処理後の色調変化が少ないのも特徴です。)<br>
SAシリーズ(強力ドライタイプの変色防止剤で銀、スズその他に使用でき優れた滑性を持っています。<br>
アルファミスト(スプレイタイプでD1Sと略同一の特性を持っています)`,
      },
      {
        anchor: "drymain01_title03",
        title: "コネクターの微摺動摩耗による接触不良-無機系と有機系の差",
        html: `コネクターはフレッティングと呼ぶ小さな振幅の周期的反復運動によって接触抵抗の増大が生ずる。<br>
この主な原因は酸化物による溜った摩耗粉によって起きている訳で、このプロセスを一般にフレッティングコロージョン " 微摺動摩耗腐食 " と呼んでいる。<br>
封孔処理剤は単にピンホールを密封するだけでなく摩耗の発生を防止する効果が必要であり、そこから得られる重要なメカニズムを掲げるならば第一に摩耗の減少、第二にセルフクリーニングとコンタクト表面から酸化物を含む摩耗粉を洗い落とすことである。<br>
そして最も重要なことは表面から酸素を追い出す働きがあることであって、これによって摩耗粉と表面の酸化作用を防止していることである。この点がドライ型とウエット型の封孔処理剤の違いであって完全なドライ型は寿命が短いと言える。<br>
<img src="https://www.factk.jp/factk/images/image4.gif" alt="試験時間と接触抵抗値のグラフ" class="dryalpha-img"><br>
<br>
<font color="#0000b4"><b>使用選択表</b></font><br>
※メッキ仕様、種類などにより結果は違ってきますのであくまでご参考まで<br>
詳しくは担当者までお問い合わせください。<br>
<img src="https://www.factk.jp/factk/images/image5.gif" alt="処理剤使用選択表" class="dryalpha-img">`,
      },
    ],
  },
  {
    label: "環境試験・作動力評価",
    sections: [
      {
        anchor: "drymain02_title01",
        title: "環境試験後の静接触抵抗評価(金メッキ板材直接評価)",
        html: `ミックスガス、硫化水素3ppm+二酸化イオウ10ppm、40℃、75%RH、48時間後<br>
測定プローブ=Pt、1φ、0.5R試料=C2680板材に下地Niメッキ1.0um+金メッキ0.1um<br>
<img src="https://www.factk.jp/factk/images/image6.jpg" alt="環境試験後の静接触抵抗評価グラフ" class="dryalpha-img">`,
      },
      {
        anchor: "drymain02_title02",
        title: "銀コンタクト作動力測定評価(処理別による)",
        html: `*測定条件( 銀:銀 ,表面粗さ約 0.6~0.8μm)<br>
*プローブ ( 銀 ,1φ,2R ,20g)<br>
<img src="https://www.factk.jp/factk/images/image8.gif" alt="銀コンタクト作動力測定評価グラフ" class="dryalpha-img"><br>
<br>
耐食試験結果顕微鏡写真<br>
ミックスガス SO2 10ppm+H2S 3ppm、40℃、75%、96時間<br>
C2680下地にニッケルメッキ1.0um,金メッキ0.1um<br>
<br>
<table border="0" cellspacing="0" cellpadding="0" style="width:100%;max-width:671px;font-size:14px;">
<tbody>
<tr>
<td width="304" valign="top"><img src="https://www.factk.jp/factk/images/image8_1.gif" alt="耐食試験結果写真 無処理" style="max-width:100%;"></td>
<td valign="top" style="padding-left:12px;">
<b>無処理</b><br>
金メッキの薄さも当然ながらミックスガスの腐食係数も高い為、かなりひどくピンホールより腐食が進んでいる
</td>
</tr>
<tr><td height="12"></td></tr>
<tr>
<td width="304" valign="top"><img src="https://www.factk.jp/factk/images/image9.gif" alt="耐食試験結果写真 他社" style="max-width:100%;"></td>
<td valign="top" style="padding-left:12px;">
<b>他社水溶系</b><br>
ピンホール腐食を少し防止しているが他の特徴が全く無い
</td>
</tr>
<tr><td height="12"></td></tr>
<tr>
<td width="304" valign="top"><img src="https://www.factk.jp/factk/images/image10.gif" alt="耐食試験結果写真 D1S" style="max-width:100%;"></td>
<td valign="top" style="padding-left:12px;">
<b>弊社D1S系</b><br>
ピンホール腐食を完全に押さえしかも接触抵抗他の総合性能も極めて高い
</td>
</tr>
</tbody>
</table>
<br>
コネクターなどの接点材料に要求される機能は耐食性、良滑性、耐摩耗性、接触抵抗、バネ性などが重要である。<br>
<br>
塩水噴霧試験結果<br>
電気接触機構部品の評価試験関連として塩水噴霧試験があります、実際の使用環境からみればガス腐食試験が一番フィールドにあっていると思われます。但し、例外として海岸のそばに置かれた電子機器の故障解析として塩水噴霧試験が存在します。<br>
理論的には電解腐食になる為と絶縁性問題の方が大きなファクターとなるので接触問題としては第一には考えません。<br>
下の写真は条件の悪い(後加工が悪い)メッキサンプルを30℃,96時間の塩水噴霧試験を行った結果を示します。<br>
(処理濃度などの条件は各メーカーの推奨濃度を参考)<br>
<br>
無処理 他社溶剤系(2)<br>
<img src="https://www.factk.jp/factk/images/image11.gif" alt="塩水噴霧試験結果写真" class="dryalpha-img"><br>
他社溶剤系(5) 弊社溶剤系(D1S)<br>
<br>
<font color="#0000b4"><b>処理皮膜の初期接触抵抗特性</b></font><br>
<img src="https://www.factk.jp/factk/images/image121.gif" alt="皮膜処理の初期接触抵抗特性" class="dryalpha-img"><br>
金メッキ:金合金プローブ、1Φ、0.5R(STATIKS)`,
      },
    ],
  },
  {
    label: "耐湿評価・樹脂影響・ルブリケーター",
    sections: [
      {
        anchor: "drymain03_title01",
        title: "コンタクトオイルの電気的耐湿評価(Cu,Ag,Au)",
        html: `コンタクト材料に使用されるルブリケーター(接点オイル他)の耐湿性評価として非常に感度の高い2電極V-I特性測定法を用いて各金属における耐湿性能を測定する。<br>
一般には各種金属の二極間に薄い有機物をはさみ、さらに電極間に電圧を印加すると流れる電流は電圧に対して非直線になり、この時の電流の伝導機構は膜の伝導体を通しての電流、トンネル電流、イオン電流などが考えられる。<br>
また絶縁体が有機物の時でも真空の場合と同様に量子学的効果によってトンネル電流の方が支配的になり、有機物のような薄膜伝導において金属酸化膜を通しての電子トンネル効果についてはよく研究されているが、コンタクトオイルの諸特性に関しては研究文献が少ないので電気接触抵抗の安定化を目的として使用されているコンタクトオイルの薄膜特性を考え一部評価したので報告します。<br>
<br>
現在接触部品の二電極間に介在するコンタクトオイルは一種の電解質として接点の接触抵抗を安定させる目的に使用されており、特に接点機構部の諸条件すなわち金属の種類と構成、表面電荷、接触力、形状、メッキ条件など更にV-I条件と外部エネルギーによる局部的変動ー電解質のイオン性、酸化還元、吸湿性、V-I条件、公害有機ガスなどを十分検討すれば接触抵抗の軽減に役立つものである。特に電極界面では伝導電子がそのまま両電極間を通過するものと、イオンなどの電極粒子に電流運搬を引受けさせるものの2種類が存在し前者をA型、後者をB型とすれば接触抵抗を低くするには何よりもB型伝導を抑制することである。<br>
B型を押さえるためには界面に水分があってはいけないし、その為には界面に水分を寄せ付けない基材を使うべきである。さらに無機や有機の半導体物質が界面で生じないような、あるいは発生したらこれを除去するような性質を持つことである。<br>
<br>
本試験で耐湿性を評価した見本写真<br>
Cu基板の例 Ag基板の例 Au基板の例<br>
<img src="https://www.factk.jp/factk/images/image13.gif" alt="耐湿試験見本写真" class="dryalpha-img"><br>
高温高湿下におけるコンタクトオイルの評価試験<br>
I-Vコンバーター回路図<br>
<br>
試験方法の特徴としては接触部品の接点金属電極は金属の種類、構成内容(3~4成分の合金etc.)メッキ条件さらに光沢剤などによって初期の電荷、さらに使用時の電極の移行があり、その初期および使用中の環境外部エネルギーに対して適切な添加剤の物理吸着力の問題、さらに帯電吸着作用が重要で、これによって耐湿性と構造に密接な関連がみられる。しがってこの試験方法によって添加剤の吸着力、および金属との適正、起電力適正添加量など各種の効果が明確に判明する。<br>
<br>
<font color="#0000b4"><b>試験方法と評価基準</b></font><br>
このような電解耐湿槽を利用してクシ型プリント電極基板に電解質であるコンタクトオイルを用いた。<br>
電極間は1mmとして各種金属を用い電圧を印加して行くと、電解質の種類、金属の種類、ピンホールによる下地金属構成有機性インヒビターの種類と濃度、更に組み合わせ等によってV-I特性の変化が生じる。<br>
この時の電圧ー電流曲線は下図のような関係がある。<br>
<img src="https://www.factk.jp/factk/images/image15.gif" alt="電圧と電流の関係グラフ" class="dryalpha-img"><br>
一般に最初は電流は少ないが、電流が急に流れ始める電圧のポイントがあり、これを分解電圧といい分解電圧に達するまでに流れる電流を残余電流といって、有機インヒビターの吸着力や添加濃度および起電圧をV=0の条件で初期の電圧を印加した後での電位差を比較すると電荷特性の強弱が判明する。<br>
ここで注意することは水素発生及び酸素発生に対する最小過電圧と電流の関係でこの点の問題も評価の一種として考えて良いが有機インヒビターの効果を明確にするには電圧の適正が重要であり1~100mV程度が望ましい。<br>
<br>
ただし実際には高温高湿の環境を仮定すると、水の理論分解電圧は1.23Vで実際の分解電圧は約1.6~1.7Vになり、それ以上では水素と酸素が発生するのでコンタクトオイルの評価電圧は有機インヒビターの場合は100mV以下で相対的には1V(max)が適正で電解質の特性が良く理解できる。しかしコンタクトオイルは電極電位-電流曲線で電流が急に流れるD点で評価できるが電極上に始めてガスが発生する電位でも決定できる。また水素ガス発生に対する最小過電圧は接点の金属種類によって異なりその順位も文献などのデーターと類似している。<br>
例えば以下の金属の順位を参照する。<br>
(例)Pt,Pd,Ru,Au,Fe,Co,Ag,Ni,Cu,Cd,Sn,Pd,Zn,Hg(高)<br>
<br>
<table border="0" cellspacing="0" cellpadding="0" style="width:100%;max-width:643px;font-size:14px;">
<tbody>
<tr>
<td colspan="2"><img src="https://www.factk.jp/factk/images/image16.gif" alt="V-I特性グラフ" style="max-width:100%;"></td>
</tr>
<tr>
<td valign="top" width="50%" style="padding-top:8px;">60℃、98%RH、120H後各サンプルの変色、腐食は全く無かった</td>
<td valign="top" width="50%" style="padding-top:8px;">同条件でCuの変色がみられた他VI特性が悪くなった</td>
</tr>
<tr>
<td valign="top" colspan="2" style="padding-top:12px;">
文献:高温高湿下におけるコンタクトオイルの分極とVI特性及びその他(二電極間に介在する有機薄膜の分極電圧による評価)<br>
株式会社スリーボンド 本多 務
</td>
</tr>
</tbody>
</table>`,
      },
      {
        anchor: "drymain03_title02",
        title: "ドライアルファ/D1S系(溶剤は含まず)の樹脂,金属に対する影響",
        html: `1. JIS K2220( 5.5)銅板腐食試験方法に基づき以下の腐食試験を行い規定時間後の表面状態を示す。<br>
2.研磨した各金属サンプルをベースオイル(溶剤希釈前)に浸し、100℃で24時間保持した後の金属板の変色状態を確認する。<br>
<br>
<table border="1" cellspacing="0" cellpadding="6" style="width:100%;max-width:678px;border-collapse:collapse;text-align:center;font-size:14px;">
<tbody>
<tr style="background:#e0f7fa;">
<td style="border:1px solid #999;padding:8px;"><b>銅</b></td>
<td style="border:1px solid #999;padding:8px;"><b>黄銅</b></td>
<td style="border:1px solid #999;padding:8px;"><b>亜鉛</b></td>
<td style="border:1px solid #999;padding:8px;"><b>ニッケル</b></td>
<td style="border:1px solid #999;padding:8px;"><b>錫</b></td>
<td style="border:1px solid #999;padding:8px;"><b>アルミ</b></td>
<td style="border:1px solid #999;padding:8px;"><b>銀</b></td>
<td style="border:1px solid #999;padding:8px;"><b>金メッキ</b></td>
</tr>
<tr>
<td style="border:1px solid #999;padding:8px;">○</td>
<td style="border:1px solid #999;padding:8px;">○</td>
<td style="border:1px solid #999;padding:8px;">○</td>
<td style="border:1px solid #999;padding:8px;">○</td>
<td style="border:1px solid #999;padding:8px;">○</td>
<td style="border:1px solid #999;padding:8px;">○</td>
<td style="border:1px solid #999;padding:8px;">○</td>
<td style="border:1px solid #999;padding:8px;">○</td>
</tr>
</tbody>
</table>
<br>
3.以上全ての試験金属に対して腐食は認められなかった金メッキ(Ni ‐2um下地, Au ‐0.2um)<br>
<br>
<br>
<font color="#0000b4"><b>プラスチックに対する影響</b></font><br>
1.一番厳しいと思われる発砲スチロール塗布試験(60℃,24時間 )に合格しておりますので以下の樹脂に対しても安心して使用できます。(D12HTは除く)<br>
<br>
<table border="1" cellspacing="0" cellpadding="6" style="width:100%;max-width:550px;border-collapse:collapse;font-size:14px;">
<tbody>
<tr style="background:#e0f7fa;">
<td style="border:1px solid #999;padding:8px;"><b>樹脂名</b></td>
<td style="border:1px solid #999;padding:8px;width:80px;text-align:center;"><b>良否</b></td>
</tr>
<tr><td style="border:1px solid #999;padding:8px;">ABS</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">PBT (ポリブチルテレフタレート)</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">PC (ポリカーボネイト)</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">PE (ポリエチレン)</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">PP (ポリプロピレン)</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">ナイロン</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">ポリアセタール (ジュラコン)</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">PVC (塩化ビニール)</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
<tr><td style="border:1px solid #999;padding:8px;">PS ( ポリスチレン)</td><td style="border:1px solid #999;padding:8px;text-align:center;">〇</td></tr>
</tbody>
</table>
<br>
<font color="#0000b4"><b>絶縁抵抗に及ぼす影響</b></font><br>
1.伝導度測定セルを用い60℃, 95%RH中で1cmの電気抵抗を100Vの測定電圧で測定した結果が以下のとおりです。<br>
<br>
<table border="1" cellspacing="0" cellpadding="6" style="width:100%;max-width:591px;border-collapse:collapse;text-align:center;font-size:14px;">
<tbody>
<tr style="background:#e0f7fa;">
<td style="border:1px solid #999;padding:8px;"><b>試験開始直後 500MΩ以上</b></td>
<td style="border:1px solid #999;padding:8px;"><b>500時間後 500MΩ以上</b></td>
</tr>
</tbody>
</table>`,
      },
      {
        anchor: "drymain03_title03",
        title: "ルブリケーターの種類",
        html: `機構部品のコンタクトの使用される防錆オイル、グリスの数は多種多様であって、使用に当たっても検討する内容が多い様におもえる。<br>
これらの使用目的金属及びメッキ別などから同製品でも当然試験結果が違うように、接触機構部品の複雑な特性が表れているようでもある。<br>
その様な防錆剤について、過去の文献及び製品の分析を行ったので参考にしていただきたい。<br>
<br>
①構成内容 形態は、オイル,グリス,ドライ状に分類され、構成としては基油,酸化安定剤,ゲル化剤,金属不活性剤,粘土指数向上剤,分散洗浄剤,油性向上剤,金属粉,防錆添加剤,顔料,染料,プラスチック等<br>
<br>
②基油の種類 (単独及び混合物)<br>
(A) 鉱 油:パラフィン系,ナフテン系,特殊製精油<br>
(B) 合成油:ジエステル2エチルヘキシル(セバケート,アジベート)及びC オキソアルコール,ネオペンチルポリオールエステル,カプロン酸(ペンタエリスリトールエステル),2エイルヘキシル酸(トリメチロールプロパネステル),ペンタエリストールカプリン酸エステル,りん酸エステル,シリケートエステル(テトラアルコキシミラン)ポリフェニールエーテル,ポリアルキレングリコール,オレフィン重合油,フッ素系,合成C.H油,植物油変性脂肪酸<br>
(C) シリコーン合成油:フロロ,メチルフェニール,ジメチル,脂肪酸変性,アミノ変性,アルキル変性,メチルハイドロジエン,メルカプト変性,ポリエーテル,ポリオキシアルキレン変性,ポリアミン変性カルバミン変性,ステアリルアミン(塩酸基)<br>
<br>
③ゲル化剤 リチューム石鹸類,アルミニューム複合石鹸,混合石鹸類,シリカ(シランカップリング処理),鉛石鹸,カルシューム石鹸,アリルウエア,ポリウレアフタロシアニン,シリカ石鹸混合類,テレフタラメート,フッ素化合物<br>
<br>
④その他 ポリメタクリレート,ポリアクリレート,エチレン(プロピレン共重合体)有機カルシューム,有機マグネシューム,有機バリューム,有機亜鉛有機鉛,有機錫,金属酸化物,金,銀,銅,アミン化合物,フェノール化合物,硫黄化合物,りん化合物,ポリイソブチレン,キレート化合物,脂肪酸(オレイン,アジピ酸)<br>
<br>
以上のような化学物などが各種混合されて、機械油の分野と同様な仕様であるが、異なる点は相手金属の種類、純度、使用条件、評価法、潤滑剤の精製度、安定性などについてであって十分に留意して使用することが重要である。`,
      },
    ],
  },
  {
    label: "腐食抑制剤",
    sections: [
      {
        anchor: "drymain04_title01",
        title: "腐食抑制剤",
        html: `腐食抑制剤(inhibitor)とは腐食環境において少量添加することによって、金属の腐食を著しく減少させるような無機又は有機薬品をいう。従来、腐食抑制剤として研究され、発見された物質は文献に、また商品として多数発表され市販されている。<br>
腐食抑制剤は腐食環境として、水溶液、酸性溶液、アルカリ性溶液、有機性溶液中で金属の腐食を防止するばかりでなく大気中の腐食を防止する目的に、広い範囲に開発されてきている。<br>
腐食抑制剤は古くは無機系の抑制剤が使用されていたが1872年頃MarangoniおよびStephonelliが精油からの有機性物質が酸による鉄の腐食を防止する事に役立つ事を発表し、有機系抑制剤の研究がなされた。<br>
その後1920年頃に窒素、ひ素、りん、いおうを含有する有機化合物が有効な腐食抑制剤であることが知られた。<br>
<br>
腐食の抑制機構に関しては、腐食抑制剤の種類、腐食環境すなわち、腐食溶媒、金属によって抑制剤の挙動はそれぞれ異なっているので、総括的に抑制剤の抑制機構を解明する事は困難である。<br>
したがって腐食抑制剤の金属に対する抑制機構には種々の説が提出されている。<br>
大別すると、吸着説、過電圧説、皮膜説などに区別され、これらの根底をなすものとして電気化学的な腐食理論の上に立った抑制機構の理論づけがなされている。<br>
一方これで解明できない腐食抑制機構に関しては、化学結合による不動態化による理論があり、両者が抑制機構の主体といえる。 電気化学的には抑制剤がアノード反応を支配するか、カソード反応を支配するかによって、それぞれの分極作用で抑制機構を一層明確に表明することもある。<br>
<br>
金属の腐食は、一般に電気化学的な解釈がなされ、カソード(cathorde)地区では次の反応が生ずる。 アノード(anode)地区では<br>
<img src="https://www.factk.jp/factk/images/image20.gif" alt="電気化学反応 カソードとアノード" class="dryalpha-img"><br>
1936年Mannは窒素を含む脂肪族アミン、芳香族アミン、異節環状窒素化合物、およびイオウを含むメルカプタン、酸素を含むアルデヒド、ケトン類は極性基を有する炭素鎖化合物で、酸溶液中で金属表面に吸着し、抑制作用を示すもので、これらの抑制剤は容易に+に電荷したoniumionに電離して、金属表面の陰極地区に吸着して、吸着膜を形成し、酸性溶液からの金属の腐食を防止すると発表している。<br>
金属表面に吸着し生成された皮膜の腐食抑制性能はHイオンの放電を阻止することにより過電圧を上昇させ、一方陽極から金属の溶出を防止する効果によるもので、それは抑制剤の分子の極性基、分子配列、分子密度および吸着速度などにより影響される。<br>
抑制剤の中では金属の陰極地区に吸着して、陰極反応を支配するものと、陽極地区に皮膜を生成し、金属の腐食を阻止するものがある。実例として脂肪族アミン、および芳香族アミンは陰極反応を阻止し、水素過電圧を高める。<br>
<img src="https://www.factk.jp/factk/images/image17.gif" alt="腐食防止の仕組み" class="dryalpha-img"><br>
この吸着皮膜は単分子層を形成する。<br>
これらアミン類の分子量と、その分子構造によって性能は異なるが、一般的に次の順位を示す。<br>
propylamine>ethylamine>methylamine>xylidine>toluidine>aniline<br>
2級アミンは1級アミンより腐食抑制性能は優れ、3級アミンは更に性能は良い。<br>
N(CH3)3>H2NC3H7 N(C2H5)>HN(C3H7)2<br>
イソ結合(iso-chain)と直鎖結合(normal chain)のそれぞれの化合物の抑制性能は一般に前者は後者に劣る。<br>
芳香族にては、性能は次のごとくである。<br>
<img src="https://www.factk.jp/factk/images/image18.gif" alt="腐食防止性能順位" class="dryalpha-img"><br>
金属表面を緻密な皮膜の生成によって、金属を腐食環境から絶縁させる抑制剤について説明する。<br>
これは中性あるいはアルカリ性溶液中における無機抑制剤、例えばクロム酸塩、縮合りん酸塩による鉄の腐食抑制作用および酸溶液中の有機イオウ化合物などは金属と不溶解性化合物の皮膜を生成して金属の腐食を防止する。クロム酸塩による水溶液中での鉄の腐食は鉄表面の酸化によるγ-Fe2O3の生成による皮膜と考えられる。これは次の反応式で表わされる。<br>
2Fe+2Na2CrO4+2H2O → Fe2O3+Cr2O3+4NaOH<br>
縮合りん酸塩は金属表面の陰極地区にて金属と錯体を作り、難溶性の保護皮膜を生成する。<br>
Mann,Lawer&Multinはアミン系の抑制剤を硫酸溶液に添加し、その中に鉄試片を16時間侵漬した後、抑制剤の添加していない硫酸溶液に入れて、性能の経時変化を測定して、アミン系皮膜生成について考察した結果を下表に示す。<br>
<br>
<table border="1" cellspacing="0" cellpadding="6" style="width:100%;max-width:696px;border-collapse:collapse;text-align:center;font-size:14px;">
<tbody>
<tr>
<td rowspan="2" style="border:1px solid #999;padding:8px;">浸 漬 液 抑</td>
<td colspan="3" style="border:1px solid #999;padding:8px;">制 率 (%)</td>
</tr>
<tr>
<td style="border:1px solid #999;padding:8px;">ジメチルアミン</td>
<td style="border:1px solid #999;padding:8px;">ジブチルアミン</td>
<td style="border:1px solid #999;padding:8px;">トリエチルアミン</td>
</tr>
<tr>
<td style="border:1px solid #999;padding:8px;">4時間後抑制剤のない酸液<br>8時間後抑制剤のない酸液<br>16時間後抑制剤のない酸液</td>
<td style="border:1px solid #999;padding:8px;">99.26<br>99.21<br>99.19<br>76.27</td>
<td style="border:1px solid #999;padding:8px;">98.4<br>96.9<br>92.7<br>74.8</td>
<td style="border:1px solid #999;padding:8px;">99.31<br>99.74<br>79.24<br>71.32</td>
</tr>
</tbody>
</table>
<br>
塩酸溶液中ではアミン系抑制剤はferric chlorideと反応してmethyl amineでは[CH3NH3][FeCl4]nH2O trimethylamineでは[(CH3)3NH][FeCl4]nH2Oの不溶解性化合物の保護皮膜を生成することが発表されている。<br>
Lenny Hugelは酸性溶液中で鉄の抑制剤としてmercaptanを使用したとき、硫化鉄の皮膜を生じた事を発表した。以上の金属の腐食抑制機構については吸着説、過電圧説、および皮膜説などによって解析される。<br>
<br>
金属の大気中の腐食は従来塗料、メッキ、耐食性皮膜金属表面の皮膜にとって腐食の進行を阻止してきている。大気中の腐食の系統的研究はVernonよってなされている。大気中の湿度と大気中の不純物腐食が進行することを示している。<br>
<img src="https://www.factk.jp/factk/images/image19.gif" alt="銀の腐食に関する大気湿度の影響" class="dryalpha-img" style="float:right;margin-left:12px;">
右図に示されているように、一定温度で大気の相対湿度が60%までは空気中での鉄の腐食は極めて少ないが60%より80%までは次第に湿度の上昇とともに腐食が増加し、相対湿度80%以上では腐食は著しく進行する事を示している。Vernonはまた大気中のゴミが腐食に影響するかについて試験を行った。モス布で被覆した鉄片と被覆しない鉄片の大気中での腐食の進行を調べた結果、被覆しない鉄片の腐食が著しく大きい結果を得た。また工業地帯ではCO2、SO2、H2S、NO2などの大気不純物の含有率が多い為に、その濃度の増加に比例して腐食は一層促進された。<br>
海岸に近い大気中ではNaClミストを含有するので腐食は増大される。<br>
大気中のこれらの腐食に対しての腐食抑制剤は大略次の二つに区別される<br>
1)non-volatile inhibitor<br>
2)volatile inhibitor<br>
non-volatile inhibitorはまた次の二つに区別される。<br>
a)contact inhibitor:金属の表面に接触させて作用するもの。<br>
b)spreading inhibitor:金属表面の湿気中に急激に拡散する抑制剤。<br>
volatile inhibitorは気相、または蒸気中で金属の腐食を防止するもので、蒸気圧の高い抑制剤でvapour phase inhibitorともいう。これは包装紙に含浸されて、包装紙と内容物の空間に蒸発してこの蒸気で完全に空間が飽和され、内在金属の腐食を阻止する。<br>
volatile inhibitorは最初にShell社の英国特許でnitrite有機化合物で、この抑制剤のvaper presserは21℃で0.0002~0.001mm/Hgの範囲であった。代表的な物として、trimethylsulphonium があげられている。<br>
また亜硝酸の有機エステルやチオ亜硝酸の有機エステルも、この種の抑制性能を有し、特にdialkylamine nitriteとmorpholine nitriteは良い性能を示した。<br>
<br>
ソ連ではdiisopropylammonium nitrite,およびdicyclohexyl-ammonium nitriteについて発表され、前者は鉄、クロム、モネルメタル、およびスズには有効であるが、銅および銅合金、銀、アルミニウム、アンチモン、鉛、亜鉛に逆に悪い抑制性能を示した。<br>
dicyclohexylammonium nitritは154.4℃で溶融し、臭気がなく1gで室温で566m での空間を飽和させる事が可能で防錆グリース防錆紙などに使用されている。<br>
1.7%diisopropylammonium nitriteは+0.4%etanolamine salicylateか0.1%sodium mercaptobenzthiozaleは優れた性能を示す。<br>
Wachter&Skeisのデーターによればalkylamine nitrite と carboxylic acid のalkylamine saltの混合物はvolatile corrosion inhibitorである。<br>
英国特許ではcyclohexylamine carbonateは鉄、亜鉛、およびクロムメッキには腐食阻止の効果を有するが、銅、マグネシウム、カドミウムには腐食抑制効果はない。Balezin,& Barannikは大気中の金属の腐食阻止にmonoetanolamine carbonateを包装紙やグリースに含浸して試験した結果、鉄に対する防食には優れているが、銅、ニッケル、およびこれらの合金にはかえって腐食を生じた。dicyclohexylamine carbonate は鉄、鉄合金、銅及び銅合金にも腐食阻止の性能を示した。<br>
<br>
<font color="#ff6633">腐食抑制剤について参考文献として防食技術ハンドブック(奥田著)から抜粋いたしましたが電気接点材料の場合は全くこれらとは違うものが多く、また毒物/発ガン性物質などが含まれる為、実験をされる場合など充分ご注意下さい。</font>`,
      },
    ],
  },
  {
    label: "銀変色防止・メッキプロセス",
    sections: [
      {
        anchor: "drymain05_title01",
        title: "銀の変色防止",
        html: `Agメッキの表面は非常に活性で表面と腐食媒体(H2S,SO2ガスなど)の反応により変色が容易に生じる。光は余分なエネルギーを与えて、Agのイオン化及びAgと腐食媒体の反応を促進させる。<br>
下表-1はAgの変色に及ぼす光波長と露光時間の影響、下表-2に露光時間による色と化学組成の変化を示した。<br>
<br>
<table border="1" cellspacing="0" cellpadding="6" style="width:100%;max-width:600px;border-collapse:collapse;text-align:center;font-size:14px;">
<tbody>
<tr style="background:#e0f7fa;">
<td rowspan="2" style="border:1px solid #999;padding:8px;">光</td>
<td colspan="5" style="border:1px solid #999;padding:8px;">露 光 時 間 (h)</td>
</tr>
<tr style="background:#e0f7fa;">
<td style="border:1px solid #999;padding:8px;">6</td>
<td style="border:1px solid #999;padding:8px;">12</td>
<td style="border:1px solid #999;padding:8px;">18</td>
<td style="border:1px solid #999;padding:8px;">24</td>
<td style="border:1px solid #999;padding:8px;">48</td>
</tr>
<tr>
<td style="border:1px solid #999;padding:8px;">2537Å<br>3650Å<br>日光</td>
<td style="border:1px solid #999;padding:8px;">変色無し<br>変色無し<br>変色無し</td>
<td style="border:1px solid #999;padding:8px;">黄色斑点<br>変色無し<br>変色無し</td>
<td style="border:1px solid #999;padding:8px;">黄-褐色<br>変化無し<br>変化無し</td>
<td style="border:1px solid #999;padding:8px;">褐-黒色<br>黄色<br>黄色斑点</td>
<td style="border:1px solid #999;padding:8px;">黒色<br>-<br>-</td>
</tr>
</tbody>
</table>
<br>
<table border="1" cellspacing="0" cellpadding="6" style="width:100%;max-width:600px;border-collapse:collapse;text-align:center;font-size:14px;">
<tbody>
<tr style="background:#e0f7fa;">
<td style="border:1px solid #999;padding:8px;">2537Å光の<br>露光時間</td>
<td style="border:1px solid #999;padding:8px;">6</td>
<td style="border:1px solid #999;padding:8px;">12</td>
<td style="border:1px solid #999;padding:8px;">18</td>
<td style="border:1px solid #999;padding:8px;">24</td>
<td style="border:1px solid #999;padding:8px;">48</td>
</tr>
<tr>
<td style="border:1px solid #999;padding:8px;">色</td>
<td style="border:1px solid #999;padding:8px;">銀色</td>
<td style="border:1px solid #999;padding:8px;">黄色</td>
<td style="border:1px solid #999;padding:8px;">黄-褐色</td>
<td style="border:1px solid #999;padding:8px;">褐-黒色</td>
<td style="border:1px solid #999;padding:8px;">黒色</td>
</tr>
<tr>
<td style="border:1px solid #999;padding:8px;">主化学組成</td>
<td style="border:1px solid #999;padding:8px;">Ag(金属)</td>
<td style="border:1px solid #999;padding:8px;">Ag2O+AgO</td>
<td style="border:1px solid #999;padding:8px;">Ag2O+AgO</td>
<td style="border:1px solid #999;padding:8px;">gO+Ag(超微粒子)</td>
<td style="border:1px solid #999;padding:8px;">Ag(超微粒子</td>
</tr>
</tbody>
</table>
<br>
これらの結果から変色生成物はAgの硫化物、塩化物又はAg粒子である。<br>
変色Agの色は生成物の化学組成によって異なる、このような変色は装飾的美観を損なうだけではなく接触抵抗を増大させ電気的特性をも劣化させる。<br>
上記のメカニズムから、Agメッキの変色防止はAgメッキ表面をO2、光、他の腐食媒体から隔離、遮断することで達成される。<br>
従来からAgメッキの変色防止として無機化合物による方法有機気化合物、界面活性剤による方法、それらを組み合わせた方法が用いられている。<br>
<br>
<b>無機化合物による処理</b><br>
いろいろな変色防止法の効果を比較するためにAgメッキを2~3μm施したテストピースを0.2%多硫化アンモニウム溶液に所定時間サンプルを浸漬し、目視により判定した(※)。<br>
<br>
Agの変色防止としてAgと同じ色調であるIn,Zn,Cd,Pd,Rh,Sn,Be,Al,Th,Zrの金属皮膜あるいは金属酸物皮膜の使用が試みられ、中でもクロム酸塩の電解処理は耐変色性に優れ最も広く使われ、次いでRh,Beなどが使われている。<br>
<br>
<b>貴金属による処理</b><br>
スズ及びスズ合金による処理<br>
ベリリウムによる処理<br>
アルミニュームによる処理<br>
クロム酸塩による処理<br>
有機化合物および界面活性剤による処理<br>
<br>
有機化合物中で変色防止に効果があったものは2-ヘプタデシルイミダゾール、2-メルカプトベンゾチアゾール、チオナリドであり、これら変色防止効果のある有機化合物には以下の共通点がある。<br>
1.PH7付近よりアルカリ性領域で処理されている。<br>
2.疎水性其(長鎖アルキル其、フェニル其)をもっている。<br>
3.>NH其か-SH其をもっている、又二重結合である。<br>
4.水に不溶<br>
5.無色に近い個体<br>
であるが逆に以上の条件に当てはまってはいるが効果の無いものとして2-メルカプトベンゾオキサゾール、2-メルカプトベンゾイミダゾールがあるがこれらとの相互関係は明確ではない。<br>
<font color="#ff6633">※ただし最近の研究ではNO2とH2Sのミックスガスがフィールドに反映した試験として最適であると報告されている。</font>`,
      },
      {
        anchor: "drymain05_title02",
        title: "コネクターへのメッキプロセス",
        html: `コネクター:回路または機器などの相互間を電気的に接続する機構部品・端子でスイッチと共に接続部品として分類され、形状によって丸型、角型、高周波同軸、プリント基板用などにわかれる。<br>
<img src="https://www.factk.jp/factk/images/image221.gif" alt="コネクターへのメッキプロセス" class="dryalpha-img"><br>
ジャパンロナール社提供プロセス例`,
      },
    ],
  },
];